import React, { Component } from 'react';
import {CONSTANT} from '../../variables';

export default class Paperform extends Component {
    constructor(props) {
        super(props)
        this.state = {
            prefillValue: "",
            value: "",
            prefill: "",
            response: null,
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.value !== this.props.value || prevProps.prefillValue !== this.props.prefillValue) {
            const v = this.props.prefillValue.split('?');
            const prefill = v[1] ? v[1] : v[0];
            this.setState({ value: this.props.value, prefill});
        }
    }
    componentDidMount() {
        let response = localStorage.getItem(CONSTANT.RESPONSE_KEYS);
        let prefillValue = '';
        if (response) {
            response = JSON.parse(response);
            const responseKeys = Object.keys(response);
            responseKeys.map(key => {
                prefillValue = prefillValue + `${key}=${response[key] ? response[key] : ''}&`
            });
        }
        const v = this.props.prefillValue.split('?');
        const prefill = v[1] ? v[1] : v[0];
        const Value = response ? prefillValue + prefill : prefill;
        this.setState({
            prefill: Value,
            prefillValue,
            response,
        });
    }
    render() {
        const {slug} = this.props;
        const { prefillValue, value, response, prefill } = this.state;
        
        return <div>
            <div data-prefill={prefill} data-paperform-id={slug}></div>
            <script>
                { typeof window !== 'undefined' && (function() {var script = document.createElement('script'); script.src = "https://paperform.co/__embed.min.js"; document.body.appendChild(script); })()}
            </script>
        </div>
    }
}